import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "external_link",
  "use": "external_link-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"external_link\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#FFF\" /><g stroke=\"#42B4E6\"><path stroke-width=\"1.5\" d=\"M6.57 2.6H.75v9h9V6.21\" /><path d=\"M11.75.6l-5 5 5-5zM7.75.6h4v4\" stroke-width=\"1.2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol